import { styled } from "@mui/material/styles";
import { Box, Button, TableCell } from "@mui/material";

export const ActionButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.jigsaw.green,
  color: "black",
  borderRadius: "8px",
  minWidth: "150px",
  height: "40px",
  padding: "0px 5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "auto",
  "& img": {
    width: "20px",
    height: "20px",
  },
  "&:hover": {
    backgroundColor: "#A0C500",
  },
}));

export const DashboardTable = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "99%",
  alignItems: "center",
  justifyContent: "flex-start",
  marginLeft: "10px",
  padding: "15px",
  maxHeight: "800px",
  height: "95%",
}));

function progressCellBackgroundColor(progress) {
  const mapping = {
    source_documents: "#D69D00",
    finalized_summary: "#D64000",
    product_comparison: "#006F68",
    client_comparison: "#005579",
    complete: "#BBD600", 
  };

  return mapping[progress] || "#ccc";
}

export const ProgressCell = styled(TableCell)(({ progress }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "5px 15px",
  borderRadius: "25px",
  backgroundColor: progressCellBackgroundColor(progress),
  color: "#FFFFFF",
  fontWeight: 500,
}));

export const PaginationStyle = styled('div')(() => ({
  paddingTop: '16px',
  paddingBottom: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ActionCell = styled(TableCell)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  background: "transparent",
}));
